/**
 * Klartext als HTML-Fragment — die eine Stelle im Modul, die aus Rohtext
 * Markup macht.
 *
 * Zwei Aufrufer, dieselbe Erwartung: `buildStageSnapshot` fällt damit auf die
 * öffentlichen Klartext-Kommentare zurück, solange das Ticketdetail noch
 * nicht geladen ist, und `useAddComment` setzt den gerade geschriebenen
 * Kommentar damit optimistisch in den Detail-Cache. Beide Ergebnisse laufen
 * danach durch `sanitizeForDisplay` — das Escapen hier ist trotzdem kein
 * Luxus: Ohne es verschwände ein `<` samt allem, was der Filter daraus macht,
 * aus dem Text, den jemand wirklich geschrieben hat.
 *
 * Escaped werden `& < > " '` (die Anführungszeichen, damit derselbe Aufruf
 * auch in einem Attributwert trägt) und Zeilenumbrüche werden zu `<br />` —
 * ein Kommentar ohne Absätze liest sich sonst als eine einzige Zeile.
 * Reihenfolge ist Pflicht: `&` zuerst, sonst escapt der Lauf seine eigenen
 * Entities ein zweites Mal.
 */
export function escapeToHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/\n/g, "<br />");
}
